import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { BackArrowIcon } from 'components/elements/Icons';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BookAppointmentService({ children, onClick }) {
  const classes = useStyles();

  return (
    <button className={classes.serviceCard} type="button" onClick={onClick}>
      <div className={classes.serviceCardInfo}>{children}</div>
      <div className={classes.arrow}>
        <BackArrowIcon />
      </div>
    </button>
  );
}

BookAppointmentService.propTypes = {
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BookAppointmentService;
